import { SearchOutlined } from '@ant-design/icons';
import { PropsFromComponent } from '@mm/utils';
import React from 'react';
import { Input } from '../Input/Input';
import '../Input/Input.module.css';

export const SearchInput = (
  props: Omit<PropsFromComponent<typeof Input>, 'icon'>,
) => <Input {...props} icon={<SearchOutlined />} />;
